<template>
  <form @submit.prevent="generate">
    <div class="modal-card" style="overflow: visible">
      <header class="modal-card-head">
        <p class="modal-card-title">Detailed Invoice Report</p>
      </header>
      <section class="modal-card-body" style="overflow: visible">
        <p class="mb-md">
          Select a date range to generate a detailed invoice report. The report
          will be delivered to your email within 5–10 minutes.
        </p>
        <div class="columns">
          <b-field label="Start Date" class="column">
            <b-datepicker
              v-model="startDate"
              placeholder="Select start date..."
              icon="calendar-today"
              :max-date="endDate || today"
              editable
              required
            />
          </b-field>
          <b-field label="End Date" class="column">
            <b-datepicker
              v-model="endDate"
              placeholder="Select end date..."
              icon="calendar-today"
              :min-date="startDate"
              :max-date="today"
              editable
              required
            />
          </b-field>
        </div>
        <p v-if="error" class="has-text-danger is-size-7 mt-sm">{{ error }}</p>
      </section>
      <footer class="modal-card-foot" style="justify-content:flex-end">
        <b-button @click="$parent.close()">Close</b-button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="isSaving"
          :disabled="isSaving || !startDate || !endDate"
        >Generate Report</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      startDate: null,
      endDate: null,
      isSaving: false,
      error: null,
      today: new Date()
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/invoices/detailed-report/'
    }
  },
  methods: {
    generate () {
      if (!this.startDate || !this.endDate) return
      this.error = null
      this.isSaving = true
      const params = {
        start_date: this.$dates(this.startDate).format('YYYY-MM-DD'),
        end_date: this.$dates(this.endDate).format('YYYY-MM-DD')
      }
      this.$http.get(this.endpoint, { params }).then(() => {
        this.isSaving = false
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'Report scheduled! Please allow 5–10 minutes for delivery.',
          duration: 5000
        })
        this.$parent.close()
      }).catch(() => {
        this.isSaving = false
        this.error = 'Something went wrong. Please try again.'
      })
    }
  }
}
</script>
